import React from 'react';
import { useTranslation } from 'react-i18next';
import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';
import _upperFirst from 'lodash/upperFirst';
import { ApiToken, ApiTokenStatusEnum } from 'graphql-common';
import Chip, { ChipSizes } from '@lib/components/Chip/Chip';
import ChipWithDropDown from '@lib/components/ChipWithDropDown/ChipWithDropDown';
import Menu, { NavItemTypeEnum } from '@lib/components/Menu/Menu';
import {
  getApiTokenStatusChipType,
  getApiTokenStatusOptions,
} from '@lib/utils/status';

type Props = {
  onStatusChangeHandler?: (id: string, newStatus: ApiTokenStatusEnum) => void;
  apiToken: ApiToken;
  isViewOnly?: boolean;
};

export default function ApiTokenStatusChip(props: Props) {
  const { t } = useTranslation();
  const { onStatusChangeHandler, apiToken, isViewOnly } = props;
  const { id, status } = apiToken;
  const options = getApiTokenStatusOptions();
  let label: string | undefined = '-';
  if (status) {
    const selectedOption = options.find(({ value }) => value === status);
    label = selectedOption?.labelKey ? t(selectedOption.labelKey) : undefined;
  }
  if (label === undefined && status) {
    label = _upperFirst(_toLower(_startCase(status)));
  }
  const type = getApiTokenStatusChipType(status);
  if (onStatusChangeHandler !== undefined && !isViewOnly) {
    const chipLeftIcon = (statusItem: ApiTokenStatusEnum) => (
      <Chip
        leftIcon="circle"
        type={getApiTokenStatusChipType(statusItem)}
        size={ChipSizes.smallLeftIconOnly}
      />
    );
    const getBody = () => (
      <Menu
        navItems={options
          .filter(({ value }) => value !== status)
          .map(({ value, labelKey }) => ({
            id: value,
            title: t(labelKey),
            onClick: () => onStatusChangeHandler(id, value),
            type: NavItemTypeEnum.Secondary,
            leftIcon: () => chipLeftIcon(value),
          }))}
      />
    );
    return (
      <div>
        <ChipWithDropDown
          label={label}
          type={type}
          leftIcon="circle"
          width={160}
          body={getBody}
        />
      </div>
    );
  }
  return <Chip type={type} label={label} leftIcon="circle" />;
}
